module.exports = __webpack_public_path__ + "img/ilustra6.1b3b8392.png";